module.exports = __webpack_public_path__ + "img/pin-pairing-logo.8a3fea39.svg";